export const formatDate = (createdAt) => {
  if (!createdAt) return null;
  
  try {
    // Parse the UTC date string and convert back to local time for display
    const date = new Date(createdAt);
    
    if (isNaN(date.getTime())) {
      return null;
    }
    
    // Use toLocaleString to display in the user's local timezone
    // This will show the time as it would appear locally when the event happens
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    
  } catch (error) {
    console.error('Error formatting date:', error);
    return null;
  }
};



  
  export const formatBirth = (dateString) => {
    const date = new Date(dateString);
  
    // Provera da li je datum validan
    if (isNaN(date)) return ""; // Ako nije validan datum, vrati praznu string
  
    // Dobijanje dana, meseca i godine
    const day = String(date.getDate()).padStart(2, "0"); // Dva cifre za dan
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Dva cifre za mesec
    const year = date.getFullYear();
  
    // Vraćanje u formatu dan-mesec-godina
    return `${day}/${month}/${year}`;
  };
  
  